import { object, array } from '@gogame/schemas';

import { CATEGORY, TAGS } from './constants';

export const tagsSchema = object({
  [CATEGORY]: object().required(),
  [TAGS]: array().required('Tags field must have at least 1 item'),
});
